// extracted by mini-css-extract-plugin
export var deleteIcon = "_l4-5";
export var deleteOption = "_l4-3";
export var divider = "_l4-2";
export var downloadIcon = "_l4-4";
export var drawer = "_l4-0";
export var drawerFooter = "_l4-6";
export var drawerOpen = "_l4-1";
export var highlighted = "_l4-7";
export var lighterHighlight = "_l4-8";